import React from 'react';
import { Course, Resource, TeamMember, NavLinkItem, User, AdminNavLinkItem } from './types';
import { 
  DocumentTextIcon, 
  VideoCameraIcon, 
  ArchiveBoxIcon, 
  AcademicCapIcon,
  ChartPieIcon,
  BookOpenIcon,
  DocumentDuplicateIcon,
  UsersIcon as GroupUsersIcon, // Renamed to avoid conflict if a single UserIcon is needed
  CogIcon 
} from './components/icons'; 

export const APP_NAME = "StudyRoom";

export const NAVIGATION_LINKS: NavLinkItem[] = [
  { label: 'Home', path: '/' },
  // { label: 'Courses', path: '/courses' }, // Hidden old courses
  { label: 'Courses', path: '/coursesv2' }, // Using V2 as main Courses
  // { label: 'Resources', path: '/resources' }, // Hidden but functionality preserved
  { label: 'Contact Us', path: '/contact' },
  { label: 'Admin Panel', path: '/admin' }, // Added Admin Panel link
];

export const ADMIN_NAVIGATION_LINKS: AdminNavLinkItem[] = [
  { label: 'Dashboard', path: '/admin/dashboard', icon: React.createElement(ChartPieIcon, {className: "w-5 h-5 mr-3"}) },
  { label: 'Courses', path: '/admin/courses', icon: React.createElement(BookOpenIcon, {className: "w-5 h-5 mr-3"}) },
  { label: 'Courses V2', path: '/admin/coursesv2', icon: React.createElement(AcademicCapIcon, {className: "w-5 h-5 mr-3"}) },
  { label: 'Resources', path: '/admin/resources', icon: React.createElement(DocumentDuplicateIcon, {className: "w-5 h-5 mr-3"}) },
  { label: 'Our Team', path: '/admin/team', icon: React.createElement(GroupUsersIcon, {className: "w-5 h-5 mr-3"}) },
  { label: 'Site Content', path: '/admin/content', icon: React.createElement(CogIcon, {className: "w-5 h-5 mr-3"}) },
  { label: 'Student Testimonies', path: '/admin/testimonies', icon: React.createElement(BookOpenIcon, {className: "w-5 h-5 mr-3"}) },
  {
    label: 'Contact Messages',
    path: '/admin/contacts',
    icon: '📩',
  },
  { label: 'Settings', path: '/admin/settings', icon: React.createElement(CogIcon, {className: "w-5 h-5 mr-3"}) },
];

// export const COURSES_DATA: Course[] = [
//   {
//     id: 'c1',
//     title: 'Advanced React Development',
//     tagline: 'Master modern React techniques for scalable applications.',
//     description: 'Dive deep into React hooks, state management, performance optimization, and testing.',
//     longDescription: 'This comprehensive course covers everything from advanced component patterns and state management with Zustand/Redux Toolkit to performance optimization techniques like memoization and code splitting. You will also learn about testing strategies using Jest and React Testing Library, and explore server components and Next.js fundamentals. By the end, you will be equipped to build complex, production-ready React applications.',
//     curriculum: ['Advanced Hooks (useReducer, useContext, custom hooks)', 'State Management (Zustand, Redux Toolkit)', 'Performance Optimization (memo, useMemo, useCallback, code splitting)', 'Testing with Jest & React Testing Library', 'Server Components & Next.js Basics', 'GraphQL Integration with Apollo Client'],
//     price: 299.99,
//     duration: '8 Weeks',
//     instructor: 'Dr. Evelyn Reed',
//     imageUrl: 'https://picsum.photos/seed/reactcourse/600/400',
//     category: 'Web Development',
//   },
//   {
//     id: 'c2',
//     title: 'Python for Data Science & AI',
//     tagline: 'Unlock the power of Python for data analysis and machine learning.',
//     description: 'Learn essential Python libraries like NumPy, Pandas, Scikit-learn, and TensorFlow.',
//     longDescription: 'Embark on a journey into the world of data science and artificial intelligence with Python. This course starts with Python fundamentals, then quickly moves into core data science libraries. You will learn data manipulation with Pandas, numerical computing with NumPy, data visualization with Matplotlib and Seaborn, and machine learning with Scikit-learn. The course culminates with an introduction to deep learning using TensorFlow and Keras.',
//     curriculum: ['Python Fundamentals & Advanced Features', 'NumPy for Numerical Computing', 'Pandas for Data Manipulation', 'Matplotlib & Seaborn for Visualization', 'Scikit-learn for Machine Learning', 'Introduction to TensorFlow & Keras'],
//     price: 349.50,
//     duration: '10 Weeks',
//     instructor: 'Prof. Kenji Tanaka',
//     imageUrl: 'https://picsum.photos/seed/pythoncourse/600/400',
//     category: 'Data Science',
//   },
//   {
//     id: 'c3',
//     title: 'UI/UX Design Fundamentals',
//     tagline: 'Create intuitive and engaging user experiences.',
//     description: 'Master user research, wireframing, prototyping, and usability testing with Figma.',
//     longDescription: 'This course provides a solid foundation in UI/UX design principles and practices. You will learn how to conduct user research, create user personas and journey maps, design wireframes and prototypes using Figma, and perform usability testing to gather feedback. Emphasis is placed on user-centered design, visual hierarchy, color theory, typography, and interaction design patterns.',
//     curriculum: ['Introduction to UI/UX Design', 'User Research & Personas', 'Wireframing & Prototyping in Figma', 'Visual Design Principles', 'Interaction Design & Usability Testing', 'Portfolio Development'],
//     price: 199.00,
//     duration: '6 Weeks',
//     instructor: 'Isabelle Moreau',
//     imageUrl: 'https://picsum.photos/seed/uicourse/600/400',
//     category: 'Design',
//   },
//   {
//     id: 'c4',
//     title: 'Cloud Computing with AWS',
//     tagline: 'Build and deploy scalable applications on Amazon Web Services.',
//     description: 'Explore core AWS services like EC2, S3, Lambda, RDS, and VPC.',
//     longDescription: 'Get hands-on experience with the leading cloud platform, AWS. This course covers essential services for compute, storage, databases, networking, and serverless computing. You will learn to deploy and manage applications, understand security best practices, and explore cost optimization strategies. Practical labs will guide you through building resilient and scalable cloud solutions.',
//     curriculum: ['Introduction to Cloud Computing & AWS', 'Core Services: EC2, S3, IAM', 'Databases on AWS (RDS, DynamoDB)', 'Networking with VPC', 'Serverless Computing with Lambda & API Gateway', 'DevOps & Infrastructure as Code (CloudFormation)'],
//     price: 400.00,
//     duration: '12 Weeks',
//     instructor: 'Raj Patel',
//     imageUrl: 'https://picsum.photos/seed/awscourse/600/400',
//     category: 'Cloud Computing',
//   },
// ];

// export const TEAM_MEMBERS_DATA: TeamMember[] = [
//   {
//     id: 'tm1',
//     name: 'Dr. Eleanor Vance',
//     role: 'Founder & Lead Instructor',
//     bio: 'With over 15 years in tech education, Dr. Vance is passionate about empowering students with cutting-edge skills and personalized coaching strategies.',
//     imageUrl: 'https://picsum.photos/seed/Eleanor/300/300',
//     specialties: ['Curriculum Development', 'AI Ethics', 'Advanced Algorithms'],
//   },
//   {
//     id: 'tm2',
//     name: 'Marcus Chen',
//     role: 'Senior Web Development Coach',
//     bio: 'Marcus is a full-stack expert with a knack for simplifying complex concepts in JavaScript, React, and Node.js. He has shipped multiple large-scale applications.',
//     imageUrl: 'https://picsum.photos/seed/Marcus/300/300',
//     specialties: ['React & Next.js', 'GraphQL', 'DevOps'],
//   },
//   {
//     id: 'tm3',
//     name: 'Aisha Khan',
//     role: 'Data Science & ML Specialist',
//     bio: 'Aisha brings real-world data science experience from the finance and healthcare sectors, focusing on practical applications of machine learning.',
//     imageUrl: 'https://picsum.photos/seed/Aisha/300/300',
//     specialties: ['Machine Learning', 'Python', 'Big Data Analytics'],
//   },
//   {
//     id: 'tm4',
//     name: 'David Miller',
//     role: 'Student Success Coordinator',
//     bio: 'David is dedicated to ensuring every student has a smooth learning journey, providing support and guidance from enrollment to course completion.',
//     imageUrl: 'https://picsum.photos/seed/David/300/300',
//     specialties: ['Student Onboarding', 'Career Coaching', 'Community Engagement'],
//   },
// ];

export const RESOURCES_DATA: Resource[] = [
  {
    id: 'r1',
    title: 'React Best Practices Guide',
    description: 'A comprehensive PDF covering modern React development patterns and performance tips.',
    fileUrl: '#', // Placeholder
    fileType: 'PDF',
    category: 'Web Development',
    type: 'document',
    icon: React.createElement(DocumentTextIcon, { className: 'w-8 h-8 text-primary' }),
  },
  {
    id: 'r2',
    title: 'Data Science Project Starter Kit',
    description: 'A ZIP archive with templates and datasets to kickstart your data science projects.',
    fileUrl: '#', // Placeholder
    fileType: 'ZIP',
    category: 'Data Science',
    type: 'document',
    icon: React.createElement(ArchiveBoxIcon, { className: 'w-8 h-8 text-primary' }),
  },
  {
    id: 'r3',
    title: 'Intro to UI Design Principles (Video)',
    description: 'A short video lecture explaining core UI design concepts for beginners.',
    fileUrl: '#', // Placeholder
    fileType: 'VIDEO',
    category: 'Design',
    type: 'video',
    icon: React.createElement(VideoCameraIcon, { className: 'w-8 h-8 text-primary' }),
  },
  {
    id: 'r4',
    title: 'AWS Certification Path Guide',
    description: 'A document outlining various AWS certifications and recommended learning paths.',
    fileUrl: '#', // Placeholder
    fileType: 'PDF',
    category: 'Cloud Computing',
    type: 'document',
    icon: React.createElement(DocumentTextIcon, { className: 'w-8 h-8 text-primary' }),
  },
  {
    id: 'r5',
    title: 'Effective Learning Strategies',
    description: 'Tips and techniques to maximize your learning effectiveness in online courses.',
    fileUrl: '#', // Placeholder
    fileType: 'PDF',
    category: 'General',
    type: 'document',
    icon: React.createElement(AcademicCapIcon, { className: 'w-8 h-8 text-primary' }),
  },
];

// export const MOCK_USERS_DATA: User[] = [
//   { id: 'u1', name: 'Alice Wonderland', email: 'alice@example.com', role: 'Student', joinedDate: '2023-01-15', lastLogin: '2024-05-01', courseIds: ['c1', 'c3'] },
//   { id: 'u2', name: 'Bob The Builder', email: 'bob@example.com', role: 'Student', joinedDate: '2023-03-22', lastLogin: '2024-05-03', courseIds: ['c2'] },
//   { id: 'u3', name: 'Charlie Brown', email: 'charlie@example.com', role: 'Instructor', joinedDate: '2022-11-01', lastLogin: '2024-05-04' },
//   { id: 'u4', name: 'Diana Prince', email: 'diana@example.com', role: 'Admin', joinedDate: '2022-05-10', lastLogin: '2024-05-05' },
//   { id: 'u5', name: 'Edward Scissorhands', email: 'edward@example.com', role: 'Student', joinedDate: '2024-02-10', lastLogin: '2024-04-28', courseIds: ['c4'] },
// ];

// export const INSTITUTE_HISTORY = "Founded in 2010, StudyRoom started with a vision to revolutionize personalized education in the tech industry. We believed that one-on-one coaching, tailored to individual learning styles and goals, could unlock unprecedented potential. Over the past decade, we've helped thousands of students and professionals achieve their career aspirations, continuously evolving our curriculum and teaching methodologies to stay at the forefront of technological advancements.";
// export const PROFESSIONAL_VALUES = [
//   { title: "Student-Centricity", description: "Our students are at the heart of everything we do. We tailor our programs and support to meet their unique needs and aspirations." },
//   { title: "Excellence in Teaching", description: "We are committed to providing the highest quality education through experienced instructors and cutting-edge curriculum." },
//   { title: "Continuous Innovation", description: "The tech world never stands still, and neither do we. We constantly update our courses and methods to reflect industry best practices." },
//   { title: "Integrity & Transparency", description: "We operate with honesty and openness in all our interactions with students, partners, and the community." },
//   { title: "Supportive Community", description: "We foster a collaborative and encouraging environment where students can learn, grow, and network." }
// ];